import { NgModule } from "@angular/core";
import { GeneralLedgerDetailListComponent } from "./GeneralLedger/StatelessComponents/general-ledger-detail-list/general-ledger-detail-list.component";
import { AgGridModule } from "ag-grid-angular";
import "ag-grid-enterprise";
import { NgxSpinnerModule } from "ngx-spinner";

@NgModule({
  declarations: [GeneralLedgerDetailListComponent],
  imports: [AgGridModule.withComponents([])],
  providers: [],
  exports: [GeneralLedgerDetailListComponent, NgxSpinnerModule]
})
export class SharedModule {}
